<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  export default {
    name: 'App'
  };

</script>


<style>

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: 100%;
    font-family: 'Inter', sans-serif;
  }

</style>